module.exports = __webpack_public_path__ + "static/media/16.db1ac46.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/16.wav
// module id = R04J
// module chunks = 0